import { SharedAngular } from '@Shared.FormGen/@types/sharedAngular';
import angular from 'angular';

angular.module('fg').component('fgImage', {
  bindings: {
    fileId: '<',
    alignment: '<'
  },
  controller: [
    '$scope',
    'fileService',
    function ($scope, fileService: SharedAngular.FileService) {
      const $ctrl = this;
      let loadedFileId = null;

      this.$onInit = function () {
        loadImageData();
      };

      this.$onChanges = function () {
        loadImageData();
      };

      function loadImageData() {
        const fileId = $ctrl.fileId;
        if (fileId === undefined || fileId === loadedFileId) {
          return;
        }

        fileService.getFileById(fileId).then((response) => {
          if (!response?.data) {
            return;
          }
          loadedFileId = fileId;
          const reader = new FileReader();
          reader.onload = () => {
            $ctrl.image = {
              src: reader.result as string,
              name: response.name
            };
            $scope.$apply();
          };
          reader.readAsDataURL(response.data as unknown as Blob);
        });
      }
    }
  ],
  templateUrl: 'angular-form-gen/form/files/image.ng.html'
});
